import { Box, TextField, InputAdornment, Popover } from '@mui/material';
import { HexColorPicker } from 'react-colorful';

const COLOR_PALETTE = [
    '#EF4444', '#F97316', '#F59E0B', '#EAB308',
    '#84CC16', '#22C55E', '#10B981', '#14B8A6',
    '#06B6D4', '#3B82F6', '#6366F1', '#8B5CF6',
    '#A855F7', '#EC4899', '#F43F5E', '#64748B',
];

const ColorPicker = ({ anchorEl, onClose, value = '', onChange }) => (
    <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
    >
        <Box sx={{ p: 2, width: 220 }}>
            <HexColorPicker
                color={value || '#3B82F6'}
                onChange={onChange}
                style={{ width: '100%' }}
            />
            <Box display="flex" flexWrap="wrap" gap={0.75} mt={1.5} mb={1}>
                {COLOR_PALETTE.map(c => (
                    <Box
                        key={c}
                        onClick={() => onChange(c)}
                        sx={{
                            width: 24, height: 24, borderRadius: '50%', bgcolor: c,
                            cursor: 'pointer',
                            border: '3px solid',
                            borderColor: value === c ? 'text.primary' : 'transparent',
                            transition: 'transform 0.1s',
                            '&:hover': { transform: 'scale(1.2)' },
                        }}
                    />
                ))}
            </Box>
            <TextField
                size="small"
                fullWidth
                variant="outlined"
                placeholder="#3B82F6"
                value={value}
                onChange={e => onChange(e.target.value)}
                slotProps={{
                    input: {
                        startAdornment: value ? (
                            <InputAdornment position="start">
                                <Box sx={{ width: 14, height: 14, borderRadius: '50%', bgcolor: value, border: '1px solid', borderColor: 'divider' }} />
                            </InputAdornment>
                        ) : null,
                    },
                }}
            />
        </Box>
    </Popover>
);

export default ColorPicker;
